const API_BASE = import.meta.env.VITE_API_URL || "http://localhost:5001";

/**
 * Get all post-its for a user
 * @param {string} token - Authentication token
 * @returns {Promise<Array>} Array of post-its
 */
export const getPostIts = async (token) => {
  try {
    const response = await fetch(`${API_BASE}/api/postits`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch post-its");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching post-its:", error);
    throw error;
  }
};

/**
 * Get only pinned post-its for a user
 * @param {string} token - Authentication token
 * @returns {Promise<Array>} Array of pinned post-its
 */
export const getPinnedPostIts = async (token) => {
  try {
    const response = await fetch(`${API_BASE}/api/postits/pinned`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch pinned post-its");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching pinned post-its:", error);
    throw error;
  }
};

/**
 * Create a new post-it
 * @param {Object} postItData - Post-it data
 * @param {string} token - Authentication token
 * @returns {Promise<Object>} Created post-it
 */
export const createPostIt = async (postItData, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/postits`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(postItData),
    });

    if (!response.ok) {
      throw new Error("Failed to create post-it");
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating post-it:", error);
    throw error;
  }
};

/**
 * Update a post-it
 * @param {string} id - Post-it ID
 * @param {Object} updates - Fields to update
 * @param {string} token - Authentication token
 * @returns {Promise<Object>} Updated post-it
 */
export const updatePostIt = async (id, updates, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/postits/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updates),
    });

    if (!response.ok) {
      throw new Error("Failed to update post-it");
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating post-it:", error);
    throw error;
  }
};

/**
 * Delete a post-it
 * @param {string} id - Post-it ID
 * @param {string} token - Authentication token
 * @returns {Promise<Object>} Deletion result
 */
export const deletePostIt = async (id, token) => {
  try {
    const response = await fetch(`${API_BASE}/api/postits/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to delete post-it");
    }

    return await response.json();
  } catch (error) {
    console.error("Error deleting post-it:", error);
    throw error;
  }
};
